import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable } from "mobx";
import { Api } from "../../../common/Api";
import { AuthRole } from "../../domains/AuthRole";
import { RolesStore } from "./RolesStore";

export class RoleEditStore {
  store: RolesStore;

  visible = false;
  saving = false;
  model = new AuthRole();

  constructor(store: RolesStore) {
    makeAutoObservable(this, {
      store: false,
    });
    this.store = store;
  }

  @action
  async edit(model) {
    this.model = { ...model };
    this.visible = true;
  }

  @action
  save(values) {
    this.saving = true;
    return Api.admin.role
      .save({ id: this.model.id, ...values })
      .then((res) => {
        this.visible = false;
        notification.success({ message: `Role ${values.name} saved` });
        this.store.refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}
